import styled from 'styled-components';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

export const Title = styled.div`
    margin-bottom: 8px;

    ${promoMedia.tablet744} {
        margin-top: 12px;
        margin-bottom: 12px;
    }
`;
export const Subtitle = styled.div``;
export const ImgContainer = styled.div`
    overflow: hidden;
    width: 100%;
    flex-shrink: 0;
    border-radius: 24px;

    ${promoMedia.tablet744} {
        border-radius: 36px;
    }

    ${promoMedia.desktop1440} {
        margin-right: 40px;
        border-radius: 40px;
    }

    img {
        width: 100%;
        max-width: 100%;
        border-radius: 24px;

        ${promoMedia.tablet744} {
            border-radius: 36px;
        }

        ${promoMedia.desktop1440} {
            border-radius: 40px;
        }
    }
`;

export const TileBlogContainer = styled.a`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 10px;

    &:last-child {
        margin-bottom: 0;
    }

    &:hover ${Title} div {
        color: ${promoColors.purple40};
    }

    &:focus-visible {
        background-color: ${promoColors.purple5};
        border-radius: 24px;
        outline: 1px dashed ${promoColors.purple40};
    }

    ${Subtitle} {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    ${ImgContainer} {
        display: ${(props) => (props.isNewsPage ? 'none' : 'block')};
        width: 100%;
        height: 223px;

        ${promoMedia.tablet744} {
            width: 504px;
            height: 335px;
        }

        ${promoMedia.desktop1440} {
            display: block;
            width: 520px;
            max-height: ${(props) => (props.isNewsPage ? '250px' : '345px')};
        }
    }

    &:first-child {
        ${ImgContainer} {
            display: block;

            ${promoMedia.tablet744} {
                width: 504px;
                height: 335px;
            }

            ${promoMedia.desktop1440} {
                width: 520px;
                max-height: 345px;
            }
        }

        ${Subtitle} {
            -webkit-line-clamp: 5;
        }
    }

    ${promoMedia.tablet744} {
        &:focus-visible {
            border-radius: 36px;
        }
    }

    ${promoMedia.desktop1440} {
        flex-direction: row;

        &:focus-visible {
            border-radius: 40px;
        }
    }
`;
export const TileBlogContent = styled.div`
    display: block;
    padding: 24px;

    ${Title} div {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    ${promoMedia.desktop1440} {
        padding: 24px 40px;
    }
`;
export const DateContainer = styled.div`
    margin-right: 24px;
`;

export const BadgesContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 8px;
    gap: 8px;

    ${promoMedia.tablet744} {
        margin-top: 12px;
        gap: 12px;
    }

    ${promoMedia.desktop1440} {
        gap: 16px;
    }
`;
